module.exports = __webpack_public_path__ + "img/Islamic Studies.2ee5c5b1.svg";